import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-warning-popup',
  templateUrl: './warning-popup.component.html',
  styleUrls: ['./warning-popup.component.scss']
})
export class WarningPopupComponent {

    name: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.name = this.data.dataKey;
    }



}
